import React, { useRef , useState, useEffect} from "react";
import Frame from "./Frame";
import {Box, useTheme, Typography,Button, ButtonBase, Stack} from "@mui/material";
import { tokens } from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

const PreviewArea = (props) =>  {

  const {} = props;

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const panelRef = useRef();

  const {width,height} = useSelector((state) => state.imageEditor);
  const frames = useSelector((state) => state.imageEditor.frames.length)
  const [playing, setPlaying] = useState(false);
  const [realWidth, setRealWidth] = useState();
  const [realHeight, setRealHeight] = useState();

  //debugger;



  const handleElementResized = () => {

    let availableWidth = panelRef.current.offsetWidth;
      
    let pixelSize = Math.floor(availableWidth/width)

    setRealWidth(pixelSize * width); 
    
    setRealHeight(pixelSize * height);
    
  };

  const resizeObserver = new ResizeObserver(handleElementResized);


  useEffect(() => {
    // the code in useEffect will be executed when the component
    // has mounted, so we are certain observedDiv.current will contain
    // the div we want to observe
    resizeObserver.observe(panelRef.current);


    // if useEffect returns a function, it is called right before the
    // component unmounts, so it is the right place to stop observing
    // the div
    return function cleanup() {
      resizeObserver.disconnect();
    }
  });


  return (

    
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
        alignItems="center"
      width = "100%"
      backgroundColor={colors.primary[300]} 
      sx={{ borderRadius:2, }}
      p=".5rem 1rem 1rem 1rem"
    >

      <Box dispay="flex" alignContent="center" mb=".2rem"><Typography variant="h3" align="center">Image Preview</Typography></Box>

      <Box
        width = "100%"
        ref={panelRef}
      ></Box>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="flex-start"
        backgroundColor="#000000"
        mt="1rem"
        width = {`${realWidth}px`}
        height = {`${realHeight}px`}
        sx={{border: `1px solid ${theme.palette.primary.main}`}}
      >
        

      </Box>
      
      <Box display ="flex" flexDirection="row" justifyContent="space-between" mb="1.5rem" >

            <Stack direction="row" spacing={2}>
              {playing}
              {frames}

            </Stack>
          </Box>


    </Box>


  );
}

export default PreviewArea;